import { render } from "./Arena_ToolsButton2.vue?vue&type=template&id=0be76c4e&scoped=true"
import script from "./Arena_ToolsButton2.vue?vue&type=script&lang=js"
export * from "./Arena_ToolsButton2.vue?vue&type=script&lang=js"

import "./Arena_ToolsButton2.vue?vue&type=style&index=0&id=0be76c4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be76c4e"]])

export default __exports__